import { Component, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';

@Component({
  selector: 'app-dcf-common-toggle',
  standalone: true,
  imports: [CommonModule, FormsModule],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DcfCommonToggleComponent), multi: true }],
  template: `
    <div>
      <label class="flex items-center">
        <input
          type="checkbox"
          [(ngModel)]="value"
          class="h-5 w-10 rounded-full">
        <span class="ml-2 text-sm text-gray-700">Toggle</span>
      </label>
    </div>
  `
})
export class DcfCommonToggleComponent implements ControlValueAccessor {
  value: boolean = false;
  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: any): void { this.value = !!value; }
  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouched = fn; }
  setDisabledState(isDisabled: boolean): void { }
}
